// Tenant utility functions

/**
 * 開始日と終了日から入居期間をフォーマットして返す
 * @param startDate - 開始日 (YYYY-MM-DD形式)
 * @param endDate - 終了日 (YYYY-MM-DD形式) または null
 * @returns "X年Yヶ月" 形式の文字列
 */
export function formatTenantDuration(startDate: string, endDate: string | null): string {
  if (!endDate) {
    return "-"
  }

  const start = new Date(startDate)
  const end = new Date(endDate)
  const durationMonths = Math.floor((end.getTime() - start.getTime()) / (1000 * 60 * 60 * 24 * 30))

  const years = Math.floor(durationMonths / 12)
  const months = durationMonths % 12

  if (years > 0) {
    return months > 0 ? `${years}年${months}ヶ月` : `${years}年`
  }
  return `${months}ヶ月`
}
